import React from 'react';
const HERO_BG_URL = 'https://cdn.magicpatterns.com/uploads/491umVAm7eRBWFDqdYscDx/HERO_V4_(2).png';
export function BackgroundDecor() {
  return <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-14" data-mp="1rhz8zzmyuqzc">
      {/* Fond du hero : filigrane « W » */}
      <div className="absolute inset-x-0 top-0 h-[760px] bg-cover bg-top bg-no-repeat sm:h-[900px] lg:h-[1000px]" style={{
      backgroundImage: `url("${HERO_BG_URL}")`
    }} data-id="element-15" data-mp="21hq525r6de1j" />
    </div>;
}